import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { colors } from '../../constants/styleConstants';

export const timeStatuses = {
  regular: 'regular',
  inactive: 'inactive',
  cancelled: 'cancelled',
};

const useStyles = makeStyles(() => ({
  root: {
    width: 67,
    height: 28,
    lineHeight: '28px',
    textAlign: 'center',
    fontFamily: 'Roboto',
    color: props => (props.active !== false && props.status === timeStatuses.regular ? colors.blue : colors.subTitle),
    borderRadius: 2,
    border: 'solid 1px #c3c3c3',
    backgroundColor: props =>
      props.active !== false && props.status === timeStatuses.regular ? colors.white : colors.darkerGray,
    opacity: props => (props.active !== false && props.status === timeStatuses.regular ? 1 : 0.5),
    cursor: props => (props.active !== false && props.status === timeStatuses.regular ? 'pointer' : 'default'),
  },
  deleteButton: {
    padding: 0,
    verticalAlign: 'middle',
    display: 'inline-block',
    '& .MuiSvgIcon-root': {
      width: '1rem',
      height: '1rem',
    },
  },
}));

const PerformanceTime = ({ time, className, active, status, edit, deleteFunc }) => {
  const classes = useStyles({ active, status });
  return (
    <div className={cn(classes.root, className)}>
      {time}
      {edit && (
        <IconButton onClick={deleteFunc} className={classes.deleteButton}>
          <Clear />
        </IconButton>
      )}
    </div>
  );
};

PerformanceTime.propTypes = {
  className: PropTypes.string,
  time: PropTypes.string.isRequired,
  active: PropTypes.bool,
  status: PropTypes.oneOf([timeStatuses.regular, timeStatuses.inactive, timeStatuses.cancelled]),
};

PerformanceTime.defaultProps = {
  active: false,
  status: timeStatuses.regular,
};

export default PerformanceTime;
